import React from "react";
import styled from "styled-components";
import Chip from "./Chip";
import { getColorCode, isEmpty } from "../utils";
import { ICONS } from "../constants/icons";

const DPCheckCard = ({
  onClick,
  onChange,
  image,
  value,
  id,
  city,
  matchPercentage,
  showCheckbox = false,
  changeOnCardClick = false,
  disabled,
  size = "sm",
}) => {
  const handleOptionClick = (e) => {
    e.stopPropagation();

    if (disabled) return;
    onChange && onChange(!value);
  };

  const handleCardClick = (e) => {
    if (changeOnCardClick && showCheckbox && !disabled) {
      onChange && onChange(!value);
    } else {
      onClick && onClick(e);
    }
  };

  return (
    <DPCheckCardContainer>
      <DPImageContainer onClick={handleCardClick}>
        {showCheckbox && (
          <CheckboxWrapper disabled={disabled} size={size}>
            <ImageCheckBox
              disabled={disabled}
              size={size}
              src={value ? ICONS.CHECKBOX_FILLED : ICONS.CHECKBOX_NOT_FILLED}
              onClick={handleOptionClick}
            />
          </CheckboxWrapper>
        )}
        <ChipWrapper size={size}>
          {!isEmpty(matchPercentage) && (
            <Chip
              size={size === "md" ? "lg" : "sm"}
              color={getColorCode(matchPercentage)}
            >
              {Math.round(matchPercentage)}% match
            </Chip>
          )}
        </ChipWrapper>
        <DPCardImage size={size} src={image} />
      </DPImageContainer>
      <DPId size={size}>{id}</DPId>
      <DPCity>{city}</DPCity>
    </DPCheckCardContainer>
  );
};

export default DPCheckCard;

export const DPCheckCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DPImageContainer = styled.div`
  position: relative;
  height: max-content;
  width: max-content;
  cursor: pointer;
`;

export const DPId = styled.div`
  margin-top: 6px;

  ${({ size }) => {
    switch (size) {
      case "md":
        return `
          font-size: 18px !important;
          line-height: 24px;
        `;
      default:
        return `
          font-size: 14px !important;
          line-height: 18px;
        `;
    }
  }}

  font-weight: 400;
`;

export const DPCity = styled.div`
  margin-top: 2px;
  font-size: 13px !important;
  font-weight: 400;
  color: #5e5e5e;
`;

export const DPCardImage = styled.img`
  ${({ size }) => {
    let imgSize;
    switch (size) {
      case "md":
        imgSize = "360px";
        break;
      default:
        imgSize = "148px";
        break;
    }
    return `
     min-width: ${imgSize};
      max-width: ${imgSize};
      min-height: ${imgSize};
      max-height: ${imgSize};
  `;
  }}

  border-radius: 12px;
  background-color: #4b4b4b;
  object-fit: contain;
`;

export const CheckboxWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;

  ${({ size }) => {
    switch (size) {
      case "md":
        return `
          width: 34px;
          height: 34px;
          border-radius: 8px;
        `;
      default:
        return `
          width: 23px;
          height: 23px;
            border-radius: 4px;
        `;
    }
  }}

  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  background-color: ${({ disabled }) => (disabled ? "#f4f4f4" : "#fff")};
  z-index: 1;
`;

export const ImageCheckBox = styled.img`
  ${({ size }) => {
    switch (size) {
      case "md":
        return `
          width: 36px;
          height: 36px;
        `;
      default:
        return `
              width: 24px;
          height: 24px;
        `;
    }
  }}

  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  // add grayscale filter if disabled
  filter: ${({ disabled }) => (disabled ? "invert(70%)" : "none")};
`;

export const ChipWrapper = styled.div`
  position: absolute;
  bottom: 14px;
  left: 8px;
`;
